import { MenuOutlined } from "@ant-design/icons";
import { Layout } from "antd";
import { connect } from "react-redux";
import { toggleSideMenu } from "../redux/layout/action";
const { Content } = Layout;
const PageTitle = (WrappedComponent) =>
  connect(
    null,
    mapDispatchToProps
  )(({ title, toggleSideMenu, ...props }) => {
    return (
      <Content
        className="site-layout-background"
        style={{
          padding: 24,
          margin: 0,
          minHeight: 280,
        }}
      >
        <div className="page-title">
          <MenuOutlined
            style={{ cursor: "pointer" }}
            onClick={toggleSideMenu}
          />{" "}
          {title}
        </div>
        <WrappedComponent {...props} />
      </Content>
    );
  });
const mapDispatchToProps = (dispatch) => ({
  toggleSideMenu: () => dispatch(toggleSideMenu()),
});
export default PageTitle;
